module.exports = __webpack_public_path__ + "img/icon_buy.8c03b6fa.png";